import { jsx as _jsx } from "react/jsx-runtime";
import { ariaDescribedByIds, enumOptionsIndexForValue, enumOptionsValueForIndex, labelValue, } from '@rjsf/utils';
import map from 'lodash/map';
import { Form } from 'semantic-ui-react';
import { getSemanticProps } from '../util';
/**
 * Returns and creates an array format required for semantic drop down
 * @param {array} enumOptions- array of items for the dropdown
 * @param {array} enumDisabled - array of enum option values to disable
 * @returns {*}
 */
function createDefaultValueOptionsForDropDown(enumOptions, enumDisabled) {
    const disabledOptions = enumDisabled || [];
    const options = map(enumOptions, ({ label, value }, index) => ({
        disabled: disabledOptions.indexOf(value) !== -1,
        key: label,
        text: label,
        value: String(index),
    }));
    return options;
}
/** The `SelectWidget` is a widget for rendering dropdowns.
 *  It is typically used with string properties constrained with enum options.
 *
 * @param props - The `WidgetProps` for this component
 */
export default function SelectWidget(props) {
    const { uiSchema, formContext, id, options, label, hideLabel, required, disabled, readonly, value, multiple, placeholder, autofocus, onChange, onBlur, onFocus, rawErrors = [], } = props;
    const semanticProps = getSemanticProps({
        uiSchema,
        formContext,
        options,
        defaultSchemaProps: {
            inverted: 'false',
            selection: true,
            fluid: true,
            scrolling: true,
            upward: false,
        },
    });
    const { enumDisabled, enumOptions, emptyValue: optEmptyVal } = options;
    const emptyValue = multiple ? [] : '';
    const dropdownOptions = createDefaultValueOptionsForDropDown(enumOptions, enumDisabled);
    const _onChange = (_, { value }) => onChange(enumOptionsValueForIndex(value, enumOptions, optEmptyVal));
    // eslint-disable-next-line no-shadow
    const _onBlur = (_, { target: { value } }) => onBlur(id, enumOptionsValueForIndex(value, enumOptions, optEmptyVal));
    const _onFocus = (_, { target: { value } }) => onFocus(id, enumOptionsValueForIndex(value, enumOptions, optEmptyVal));
    const selectedIndexes = enumOptionsIndexForValue(value, enumOptions, multiple);
    return (_jsx(Form.Dropdown, { id: id, name: id, label: labelValue(label || undefined, hideLabel, false), multiple: typeof multiple === 'undefined' ? false : multiple, value: typeof value === 'undefined' ? emptyValue : selectedIndexes, error: rawErrors.length > 0, disabled: disabled, placeholder: placeholder, ...semanticProps, required: required, autoFocus: autofocus, readOnly: readonly, options: dropdownOptions, onChange: _onChange, onBlur: _onBlur, onFocus: _onFocus, "aria-describedby": ariaDescribedByIds(id) }, id));
}
//# sourceMappingURL=SelectWidget.js.map